/**
 * Implements autocomplete input
 */
export default {
  methods: {
    /**
     * @vuese
     * Initiate jquery autocomplete input
     */
    initAutocompleteField(inputObj) {
      // Get options
      let options = inputObj.el.data('autocomplete-options')
      if (Array.isArray(options) && options.length > 0) {
        let element = inputObj.el
        const confings = {}
        // If is hidden, change init element
        if (inputObj.el.attr('type') === 'hidden') {
          inputObj.autocompleteField = $(`input[data-for="${inputObj.id}"]`)
          element = inputObj.autocompleteField
          // Update main field on select
          confings.select = (evt, ui) => {
            inputObj.el.val(ui.item.value)
            inputObj.el.change()
          }
          // Handle clear
          inputObj.el.on('change', () => {
            const value = inputObj.el.val()
            if (!value) {
              inputObj.autocompleteField.val('')
            }
          })
        }
        // Init autocomplete input
        element.autocomplete({
          source: options,
          minLength: 0,
          ...confings
        })
      } else {
        this.$logger.debug('No options found', options)
      }
      return inputObj
    },
  },
}
